<template>
  <div class="row m-0">
    <div class="w-50 w-sm-100 m-md-auto mobile pt-2">
      <div class="py-md-0">
        <div
          v-if="errorInput || validateInput(error, 'nomobiletext', null)"
          class="error-message error-text mb-3"
        >
          <div v-if="validateInput(error, 'nomobiletext', null)">
            Please enter a mobile number
          </div>
          <div v-else-if="errorInput">Please enter a valid mobile number</div>
        </div>
        <p class="text-message">
          We will send One Time Password(OTP) on your mobile number to verify
          your mobile number.
        </p>

        <!-- <label class="w-100 pure-material-textfield-outlined my-2 showIsdCodeClass"
                           :class="{'error-input': errorInput === true, 'error-no-input': validateInput(error, 'nomobiletext', true)}">

                    <span class="isd-code">

                        <span class="dropdown">

                            <button type="button" class="btn btn-select" v-b-toggle.dropdown-isd>
                                {{fetch_data.isdcode}}
                                <span class="entity-down d-inline-block"><down-arrow></down-arrow></span>
                            </button>

                            <b-collapse id="dropdown-isd" v-model="countryCodeDropDown">
                                <ul class="dropdown-menu dropdown-menu-select">

                                  <li v-for="country in countryList" :key="country.key">
                                    <label class="dropdown-radio">
                                        <input type="radio" v-model="fetch_data.isdcode" v-on:change="setOption"
                                               :value="country.key">
                                        <i>{{country.value}}</i>
                                    </label>
                                  </li>

                                </ul>
                            </b-collapse>
                        </span>
                     </span>

                        <input placeholder=" " name="mobile" id="mobile" v-model="fetch_data.mobile" v-on:focus="resetError"
                               autocomplete="off" @keyup.enter="addMobile" v-on:keyup="formatPhoneNumber(fetch_data.mobile)">
                        <span class="mobileNumberInput">Enter Mobile Number</span>
                    </label> -->
      
        <AIntTelephone
          :placeholder="'Enter Phone Number'"
          validateStatus="success"
          :phoneInput="phoneInput"
          @change="mobileInputChange"
        ></AIntTelephone>
        <div class="pt-3">
          <button
            type="submit"
            name="SubmitLogin"
            class="btn-danger mdc-theme--primary-shape-bg w-100"
            v-on:click="addMobile"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownArrow from "../DownArrow";
import Validation from "../mixins/Validation";
import CountryCode from "../mixins/CountryCode";
import CommonCode from "../mixins/CommonCode";
import UserUtils from "../mixins/UserUtils";
import { AIntTelephone } from "@canvas/componentlibrary";

export default {
  mixins: [Validation, CountryCode, CommonCode, UserUtils],

  components: {
    DownArrow,
    AIntTelephone
  },

  data() {
    return {
      phoneInput: {
        number: "",
        initialisationOptions: {
          allowDropdown: true,
          formatOnDisplay: true,
          nationalMode: true,
          initialCountry: "in",
          preferredCountries: ["in", "sg", "my", "sa"],
          separateDialCode: true,
        },
      },
    };
  },

  methods: {

    mobileInputChange(event) {
      this.fetch_data.isdcode =
        "+" + event.intlTelInputSettings.activeItem.dataset.dialCode;
      this.fetch_data.countryCode =
        event.intlTelInputSettings.activeItem.dataset.countryCode;
      this.phoneInput.number = event.number;
      this.fetch_data.mobile=this.phoneInput.number;
    },

    addMobile() {
      let data = {};
      data["mobile"] = this.fetch_data.mobile;
      data["isdcode"] = this.fetch_data.isdcode;
      data["back"] = this.$route.name;
      data["username"]=this.fetch_data.mobile;
      data['type']='phone';
      if (!this.formValidation()) return this.formValidation();

      this.$router.push(
        { name: this.getVerifyMobileEntity(), params: data },
        () => {}
      );
    },

    formValidation() {
      this.error = {};

      if (!this.fetch_data.mobile) {
        this.error.nomobiletext = true;
        return false;
      } else if (
        !this.isPhoneValid(this.fetch_data.mobile, this.fetch_data.isdcode)
      ) {
        this.errorInput = true;
        return false;
      }
      return true;
    },
  },
};
</script>


<style scoped>
</style>
